module.exports = __webpack_public_path__ + "static/media/icon-tree-opacity.486844d9.png";